/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidateStreamConfigBody
 */
export interface ValidateStreamConfigBody {
    /**
     * 
     * @type {string}
     * @memberof ValidateStreamConfigBody
     */
    platform: ValidateStreamConfigBodyPlatformEnum;
    /**
     * 
     * @type {string}
     * @memberof ValidateStreamConfigBody
     */
    twitchChannelId?: string;
    /**
     * 
     * @type {string}
     * @memberof ValidateStreamConfigBody
     */
    kickChannelSlug?: string;
    /**
     * 
     * @type {string}
     * @memberof ValidateStreamConfigBody
     */
    youtubeChannelId?: string;
}


/**
 * @export
 */
export const ValidateStreamConfigBodyPlatformEnum = {
    TWITCH: 'TWITCH',
    YOUTUBE: 'YOUTUBE',
    KICK: 'KICK',
    MULTI: 'MULTI'
} as const;
export type ValidateStreamConfigBodyPlatformEnum = typeof ValidateStreamConfigBodyPlatformEnum[keyof typeof ValidateStreamConfigBodyPlatformEnum];


/**
 * Check if a given object implements the ValidateStreamConfigBody interface.
 */
export function instanceOfValidateStreamConfigBody(value: object): value is ValidateStreamConfigBody {
    if (!('platform' in value) || value['platform'] === undefined) return false;
    return true;
}

export function ValidateStreamConfigBodyFromJSON(json: any): ValidateStreamConfigBody {
    return ValidateStreamConfigBodyFromJSONTyped(json, false);
}

export function ValidateStreamConfigBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateStreamConfigBody {
    if (json == null) {
        return json;
    }
    return {
        
        'platform': json['platform'],
        'twitchChannelId': json['twitchChannelId'] == null ? undefined : json['twitchChannelId'],
        'kickChannelSlug': json['kickChannelSlug'] == null ? undefined : json['kickChannelSlug'],
        'youtubeChannelId': json['youtubeChannelId'] == null ? undefined : json['youtubeChannelId'],
    };
}

export function ValidateStreamConfigBodyToJSON(json: any): ValidateStreamConfigBody {
    return ValidateStreamConfigBodyToJSONTyped(json, false);
}

export function ValidateStreamConfigBodyToJSONTyped(value?: ValidateStreamConfigBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'platform': value['platform'],
        'twitchChannelId': value['twitchChannelId'],
        'kickChannelSlug': value['kickChannelSlug'],
        'youtubeChannelId': value['youtubeChannelId'],
    };
}

